import { render } from "./RotuloModal.vue?vue&type=template&id=1099f56f&scoped=true"
import script from "./RotuloModal.vue?vue&type=script&lang=js"
export * from "./RotuloModal.vue?vue&type=script&lang=js"

import "./RotuloModal.vue?vue&type=style&index=0&id=1099f56f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1099f56f"]])

export default __exports__